// Consulta la metadata JSON de un servicio ArcGIS REST.
// El asistente de capas ArcGIS la invocaba como `this.fetchArcgisMetadata(...)` sin que
// estuviera definida en el componente ni en sus mixins: el paso 1 siempre terminaba en
// "this.fetchArcgisMetadata is not a function" y nunca se llegaba a cargar los campos.

const DEFAULT_TIMEOUT_MS = 15000

export async function fetchArcgisMetadata (url, { timeoutMs = DEFAULT_TIMEOUT_MS } = {}) {
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs)

  let response
  try {
    response = await fetch(url, { signal: controller.signal })
  } catch (error) {
    // Sin este mensaje propio el usuario lee "The user aborted a request", que no le dice nada.
    if (error.name === 'AbortError') {
      throw new Error('El servicio no respondió a tiempo. Revisa la URL y la conexión.')
    }
    throw new Error('No fue posible conectarse al servicio. Revisa la URL.')
  } finally {
    clearTimeout(timeoutId)
  }

  if (!response.ok) {
    throw new Error(`El servicio respondió ${response.status} ${response.statusText}.`)
  }

  try {
    return await response.json()
  } catch (error) {
    throw new Error('El servicio no devolvió JSON. Revisa que la URL apunte a un servicio ArcGIS REST.')
  }
}
